import React from 'react'
import moment from 'moment'
import { Button } from '@mui/material'
import { supportType } from '../services/types/APIResponseType'

interface TicketTableProps {
  ticketList: { data: { support: supportType[] } }
  onRowClick: (item: supportType) => void
}

const TicketTable: React.FC<TicketTableProps> = ({
  ticketList,
  onRowClick,
}) => {
  return (
    <table className="table-container bg-grad before:rounded-[20px] rounded-[20px]">
      <thead>
        <tr className="table-heading row-bg1">
          <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
            Name
          </th>
          <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
            Phone Number
          </th>
          <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
            Email Address
          </th>
          <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
            Date & Time
          </th>
          <th className="text-left">Action</th>
        </tr>
      </thead>
      <tbody>
        {ticketList.data.support.map((item: supportType, idx: number) => (
          <tr key={idx} className={idx % 2 === 0 ? 'rowbg2' : 'row-bg1'}>
            <td className="border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
              <div className="text-left">
                {item?.profileId?.firstName} {item?.profileId?.lastName}
                {item?.markAsClosed && (
                  <span className="ml-2 bg-[#00BA60] text-sm py-1 px-2 rounded-full text-normal">
                    Closed
                  </span>
                )}
              </div>
            </td>
            <td className="border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
              {item?.profileId?.countryCode} {item?.profileId?.phone}
            </td>
            <td className="border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
              {item?.userId?.email}
            </td>
            <td className="whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
              {moment(item?.updatedAt).format('YYYY/MM/DD | h:mm')}
            </td>
            <td>
              <Button onClick={() => onRowClick(item)}>
                <img src="/icon/eye icon.png" alt="watch" />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default TicketTable
